// Safety net so the nudge cannot remain visible indefinitely for non-interacting users.
export const THIRTY_DAYS_MS: number = 30 * 24 * 60 * 60 * 1000;
